"use strict";
(self["webpackChunkessent_zakelijk"] = self["webpackChunkessent_zakelijk"] || []).push([[979],{

/***/ 55979:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"totalReviewsText":"onafhankelijke beoordelingen via Klantenvertellen.nl","recommendationText":"Beveelt {{brand}} aan","readMore":"Lees meer","readLess":"Lees minder","a11y.averageScore":"De gemiddelde beoordeling van {{brand}} is {{rating}}","a11y.reviewScore":"De review geeft een beoordeling van {{rating}}","a11y.dateSection":"Deze review is geplaatst op","a11y.reviewerSection":"Deze review is geplaatst door"}');

/***/ })

}]);